var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FinishedAt',{staticClass:"finished-at",attrs:{"date":_vm.date}},[_c('img',{staticClass:"icon",attrs:{"src":require("./images/desktop-timer.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }